import IcUndo from "../../assets/icons/ic-undo.svg";
import IcRedo from "../../assets/icons/ic_redo.svg";

export const getUndoManagerPanelProperties = () => {
    return {
        id: "editor-header-undo-manager-panel",
        el: ".undo-manager-icon-wrap",
        buttons: [
            {
                id: "undo",
                className: "gjs-btn-toggle-undo",
                label: `<img src='${IcUndo}' alt="editor header undo button" />`,
                command: "undo",
                attributes: {
                    title: "Undo (CTRL/CMD + Z)",
                },
            },
            {
                id: "redo",
                className: "gjs-btn-toggle-redo reverse",
                label: `<img src='${IcRedo}' alt="editor header redo button" style="transform: scaleX(1)"/>`,
                command: "redo",
                attributes: {
                    title: "Redo (CTRL/CMD + Y)",
                },
            }
        ]
    }
}

export const getDevicePanelProperties = () => {
    return {
        id: "panel-devices",
        el: ".panel_devices",
        buttons: [
            {
                id: "panel-device-pc-btn",
                className: "devices-desktop-btn",
                label: `Pc`,
                command: "set-device-desktop",
                attributes: {
                    class: 'active'
                },
                active: true,
                togglable: false,
            },
            {
                id: "panel-device-mobile-btn",
                className: "devices-mobile-btn",
                label: `Mobile`,
                command: "set-device-mobile",
                attributes: {
                    class: ''
                },
                togglable: false,
            },
        ]
    }
}


export const getCommonModalDevicePanelProperties = () => {
    return {
        id: "common-modal-panel-devices",
        el: ".common-modal-panel_devices",
        buttons: [
            {
                id: "common-modal-panel-device-pc-btn",
                className: "common-modal-devices-desktop-btn",
                label: `Pc`,
                command: "common-modal-set-device-desktop",
                attributes: {
                    class: 'active'
                },
                active: true,
                togglable: false,
            },
            {
                id: "common-modal-panel-device-mobile-btn",
                className: "common-modal-devices-mobile-btn",
                label: `Mobile`,
                command: "common-modal-set-device-mobile",
                attributes: {
                    class: ''
                },
                togglable: false,
            },
        ]
    }
}
// export const getDevicePanelProperties = () => {
//     return {
//         id: "editor-preview-modal-device-panel",
//         el: "#preview-modal-device-wrap",
//         buttons: [
//             {
//                 id: "preview-modal-pc-btn",
//                 className: "gjs-btn-toggle-preview-modal-pc",
//                 label: `PC`,
//                 command: "set-device-desktop",
//                 attributes: {
//                     className: 'nav active'
//                 }
//             },
//             {
//                 id: "preview-modal-mobile-btn",
//                 className: "gjs-btn-toggle-preview-modal-mobile",
//                 label: `Mobile`,
//                 command: "set-device-mobile",
//                 attributes: {
//                     className: 'nav'
//                 }
//             },
//         ]
//     }
// }